import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Check, X, Trash2 } from "lucide-react";

export default function AdminStoriesPage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("pending");

  const load = async () => {
    const { data } = await api.get(`/admin/stories${filter ? `?status=${filter}` : ""}`);
    setItems(data || []);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const setStatus = async (id, status) => {
    await api.put(`/admin/stories/${id}`, { status });
    load();
  };
  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/admin/stories/${id}`); load(); };

  return (
    <div data-testid="admin-stories">
      <h1 className="font-serif text-4xl text-cc-text mb-2">Capella Stories</h1>
      <p className="text-sm text-cc-muted mb-8">Kullanıcı hikâyeleri onayı</p>

      <div className="flex gap-3 mb-6">
        {[
          { v: "pending", l: "Bekliyor" },
          { v: "approved", l: "Onaylı" },
          { v: "rejected", l: "Reddedildi" },
          { v: "", l: "Tümü" },
        ].map((f) => (
          <button key={f.v || "all"} onClick={() => setFilter(f.v)} data-testid={`story-filter-${f.v || "all"}`}
            className={`text-xs uppercase tracking-overline px-3 py-2 border ${filter === f.v ? "border-cc-sepia text-cc-sepia" : "border-admin-border text-cc-muted hover:text-cc-text"}`}>
            {f.l}
          </button>
        ))}
      </div>

      <div className="space-y-4">
        {items.length === 0 && <p className="text-cc-muted">Bu kategoride hikâye yok.</p>}
        {items.map((s) => (
          <div key={s.id} className="bg-white border border-admin-border p-6" data-testid={`story-${s.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-1">{s.status}</div>
                <h3 className="font-serif text-xl text-cc-text mb-2">{s.title}</h3>
                <p className="text-sm text-cc-muted leading-relaxed mb-3">{s.message}</p>
                <div className="text-xs text-cc-muted">— {s.name} · {s.email} · {s.location_context || "Konum belirtilmedi"}</div>
              </div>
              <div className="flex flex-col gap-2 shrink-0">
                {s.status !== "approved" && <button onClick={() => setStatus(s.id, "approved")} className="text-emerald-700 hover:bg-emerald-50 p-2 rounded" title="Onayla"><Check size={16} /></button>}
                {s.status !== "rejected" && <button onClick={() => setStatus(s.id, "rejected")} className="text-amber-700 hover:bg-amber-50 p-2 rounded" title="Reddet"><X size={16} /></button>}
                <button onClick={() => del(s.id)} className="text-red-600 hover:bg-red-50 p-2 rounded" title="Sil"><Trash2 size={16} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
